import React from "react";
import { ColumnProps } from ".";
import { ColumnWrapper } from "./ReactBaseTableWrapper";

/**
 * Column for {Table}.
 */
export function Column<TData, TItem>(props: ColumnProps<TData, TItem>) {
    return <ColumnWrapper {...props} />;
}